import { render } from "./DisplayFirResult.vue?vue&type=template&id=2b397246&scoped=true"
import script from "./DisplayFirResult.vue?vue&type=script&lang=js"
export * from "./DisplayFirResult.vue?vue&type=script&lang=js"

import "./DisplayFirResult.vue?vue&type=style&index=0&id=2b397246&scoped=true&lang=css"

import exportComponent from "E:\\wamp64\\www\\law-firm-system-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b397246"]])

export default __exports__